import { yupResolver } from "@hookform/resolvers/yup";
import { VStack } from "native-base";
import React from "react";
import { useForm } from "react-hook-form";

import FormButton from "@/components/atoms/FormButton";
import SecureTextInput from "@/components/atoms/SecureTextInput";
import FormField from "@/components/molecules/FormField";

import { ChangePasswordFormData, changePasswordFormSchema } from "../schema";
import { ChangePassFormComponentProps } from "../types";

const ChangePasswordForm = ({ isSubmiting, onSubmit, onCancel }: ChangePassFormComponentProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ChangePasswordFormData>({
    resolver: yupResolver(changePasswordFormSchema),
  });
  return (
    <VStack>
      <FormField
        control={control}
        name="password"
        label="Nova senha"
        hint="Pelo menos 8 caracteres com letras e números"
        required
        error={errors.password}
        render={(value, onChange) => (
          <SecureTextInput value={value} onChangeText={onChange} placeholder="Senha" />
        )}
      />
      <FormField
        control={control}
        name="confirmPassword"
        label="Confirma e senha"
        hint="Pelo menos 8 caracteres com letras e números"
        required
        error={errors.confirmPassword}
        render={(value, onChange) => (
          <SecureTextInput value={value} onChangeText={onChange} placeholder="Confirma e senha" />
        )}
      />
      <FormButton mt="10" isLoading={isSubmiting} onPress={handleSubmit(onSubmit)}>
        Alterar Senha
      </FormButton>
      <FormButton
        colorScheme="white"
        textColor="primary.700"
        my="4"
        shadow="2"
        onPress={() => onCancel()}>
        Cancelar
      </FormButton>
    </VStack>
  );
};

export default ChangePasswordForm;
